"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LinkListCard = exports.LinkTypeForm = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const design_system_1 = require("@hashintel/design-system");
const material_1 = require("@mui/material");
const hooks_1 = require("material-ui-popup-state/hooks");
const react_1 = require("react");
const react_hook_form_1 = require("react-hook-form");
const entity_types_options_context_1 = require("../shared/entity-types-options-context");
const ontology_functions_context_1 = require("../shared/ontology-functions-context");
const read_only_context_1 = require("../shared/read-only-context");
const urls_1 = require("../shared/urls");
const link_entity_type_selector_1 = require("./link-list-card/link-entity-type-selector");
const empty_list_card_1 = require("./shared/empty-list-card");
const entity_type_table_1 = require("./shared/entity-type-table");
const insert_type_row_1 = require("./shared/insert-type-row");
const link_1 = require("./shared/link");
const multiple_values_cell_1 = require("./shared/multiple-values-cell");
const question_icon_1 = require("./shared/question-icon");
const type_form_1 = require("./shared/type-form");
const type_menu_cell_1 = require("./shared/type-menu-cell");
const use_filter_type_options_1 = require("./shared/use-filter-type-options");
const use_state_callback_1 = require("./shared/use-state-callback");
const use_type_versions_1 = require("./shared/use-type-versions");
const version_upgrade_indicator_1 = require("./shared/version-upgrade-indicator");
const formDataToEntityType = (data) => ({
    type: "object",
    kind: "entityType",
    title: data.name,
    description: data.description,
    allOf: [
        {
            $ref: urls_1.linkEntityTypeUrl,
        },
    ],
    properties: {},
});
const LinkTypeForm = (props) => {
    const { validateTitle: remoteValidation } = (0, ontology_functions_context_1.useOntologyFunctions)();
    const validateTitle = async (title) => remoteValidation({
        kind: "entity-type",
        title,
    });
    return (0, jsx_runtime_1.jsx)(type_form_1.TypeForm, { validateTitle: validateTitle, ...props });
};
exports.LinkTypeForm = LinkTypeForm;
const LinkTypeRow = ({ linkIndex, onRemove, onUpdateVersion, flash, }) => {
    const isReadonly = (0, read_only_context_1.useIsReadonly)();
    const { updateEntityType } = (0, ontology_functions_context_1.useOntologyFunctions)();
    const editModalPopupId = (0, react_1.useId)();
    const editModalPopupState = (0, hooks_1.usePopupState)({
        variant: "popover",
        popupId: `editLink-${editModalPopupId}`,
    });
    const { control } = (0, react_hook_form_1.useFormContext)();
    const { linkTypes } = (0, entity_types_options_context_1.useEntityTypesOptions)();
    const linkId = (0, react_hook_form_1.useWatch)({
        control,
        name: `links.${linkIndex}.$id`,
    });
    const link = linkTypes[linkId];
    const [currentVersion, latestVersion, baseUrl] = (0, use_type_versions_1.useTypeVersions)(linkId, linkTypes);
    if (!link) {
        throw new Error(`Link entity type with ${linkId} not found in options`);
    }
    const onUpdateVersionRef = (0, react_1.useRef)(onUpdateVersion);
    (0, react_1.useLayoutEffect)(() => {
        onUpdateVersionRef.current = onUpdateVersion;
    });
    const handleSubmit = async (data) => {
        if (isReadonly) {
            return;
        }
        const res = await updateEntityType({
            data: {
                entityTypeId: link.$id,
                entityType: formDataToEntityType(data),
            },
        });
        if (!res.data) {
            throw new Error("Failed to update entity type");
        }
        onUpdateVersionRef.current(res.data.schema.$id);
        editModalPopupState.close();
    };
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)(entity_type_table_1.EntityTypeTableRow, { flash: flash, children: [(0, jsx_runtime_1.jsx)(material_1.TableCell, { children: (0, jsx_runtime_1.jsxs)(entity_type_table_1.EntityTypeTableTitleCellText, { children: [(0, jsx_runtime_1.jsx)(link_1.Link, { href: link.$id, style: { color: "inherit", fontWeight: 600 }, children: link.title }), currentVersion !== latestVersion && !isReadonly ? ((0, jsx_runtime_1.jsx)(material_1.Box, { ml: 1, children: (0, jsx_runtime_1.jsx)(version_upgrade_indicator_1.VersionUpgradeIndicator, { currentVersion: currentVersion, latestVersion: latestVersion, onUpdateVersion: () => {
                                            if (latestVersion) {
                                                onUpdateVersion(`${baseUrl}v/${latestVersion}`);
                                            }
                                        } }) })) : null] }) }), (0, jsx_runtime_1.jsx)(material_1.TableCell, { sx: { py: "0 !important" }, children: (0, jsx_runtime_1.jsx)(link_entity_type_selector_1.LinkEntityTypeSelector, { linkIndex: linkIndex }) }), (0, jsx_runtime_1.jsx)(multiple_values_cell_1.MultipleValuesCell, { index: linkIndex, variant: "link" }), (0, jsx_runtime_1.jsx)(type_menu_cell_1.TypeMenuCell, { typeId: link.$id, editButtonProps: (0, hooks_1.bindTrigger)(editModalPopupState), ...(currentVersion !== latestVersion
                            ? {
                                editButtonDisabled: "Update the link type to the latest version to edit",
                            }
                            : {}), variant: "link", onRemove: onRemove })] }), (0, jsx_runtime_1.jsx)(type_form_1.TypeFormModal, { as: exports.LinkTypeForm, popupState: editModalPopupState, modalTitle: (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: "Edit link" }), onSubmit: handleSubmit, submitButtonProps: { children: (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: "Edit link" }) }, disabledFields: ["name"], getDefaultValues: () => ({
                    name: link.title,
                    description: link.description,
                }) })] }));
};
const InsertLinkRow = (props) => {
    const { control } = (0, react_hook_form_1.useFormContext)();
    const links = (0, react_hook_form_1.useWatch)({ control, name: "links" });
    const { linkTypes: linkTypeOptions } = (0, entity_types_options_context_1.useEntityTypesOptions)();
    const linkTypes = Object.values(linkTypeOptions);
    const filteredLinkTypes = (0, use_filter_type_options_1.useFilterTypeOptions)({
        typesToExclude: links,
        typeOptions: linkTypes,
    });
    return ((0, jsx_runtime_1.jsx)(insert_type_row_1.InsertTypeRow, { ...props, options: filteredLinkTypes, variant: "link" }));
};
const LinkListCard = () => {
    const { control, setValue } = (0, react_hook_form_1.useFormContext)();
    const { fields: unsortedFields, append, remove, } = (0, react_hook_form_1.useFieldArray)({ control, name: "links" });
    const { linkTypes } = (0, entity_types_options_context_1.useEntityTypesOptions)();
    const { createEntityType } = (0, ontology_functions_context_1.useOntologyFunctions)();
    const isReadonly = (0, read_only_context_1.useIsReadonly)();
    const fields = (0, react_1.useMemo)(() => (0, entity_type_table_1.sortRows)(unsortedFields, (linkId) => linkTypes[linkId], (row) => row.title), [linkTypes, unsortedFields]);
    const [flashingRows, flashRow] = (0, entity_type_table_1.useFlashRow)();
    const [addingNewLink, setAddingNewLink] = (0, use_state_callback_1.useStateCallback)(false);
    const addingNewLinkRef = (0, react_1.useRef)(null);
    const [searchText, setSearchText] = (0, react_1.useState)("");
    const modalId = (0, react_1.useId)();
    const createModalPopupState = (0, hooks_1.usePopupState)({
        variant: "popover",
        popupId: `createLink-${modalId}`,
    });
    const cancelAddingNewLink = () => {
        setAddingNewLink(false);
        setSearchText("");
    };
    const handleAddEntityType = (link) => {
        cancelAddingNewLink();
        append({
            $id: link.$id,
            entityTypes: [],
            minValue: 0,
            maxValue: 1,
            infinity: true,
            array: true,
        }, { shouldFocus: false });
        flashRow(link.$id);
    };
    const handleSubmit = async (data) => {
        if (isReadonly) {
            return;
        }
        const res = await createEntityType({
            data: {
                entityType: formDataToEntityType(data),
            },
        });
        if (res.errors?.length || !res.data) {
            // @todo handle this
            throw new Error("Could not create");
        }
        handleAddEntityType(res.data.schema);
    };
    if (!addingNewLink && fields.length === 0) {
        return ((0, jsx_runtime_1.jsx)(empty_list_card_1.EmptyListCard, { onClick: isReadonly
                ? undefined
                : () => {
                    setAddingNewLink(true, () => {
                        addingNewLinkRef.current?.focus();
                    });
                }, icon: (0, jsx_runtime_1.jsx)(design_system_1.LinkIcon, {}), headline: isReadonly ? (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: "No links defined" }) : (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: "Add a link" }), description: (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: "Links contain information about connections or relationships between different entities" }), subDescription: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: ["e.g. a ", (0, jsx_runtime_1.jsx)("strong", { children: "company" }), " entity might have a", " ", (0, jsx_runtime_1.jsx)("strong", { children: "CEO" }), " link which points to a ", (0, jsx_runtime_1.jsx)("strong", { children: "person" }), " ", "entity"] }) }));
    }
    return ((0, jsx_runtime_1.jsxs)(entity_type_table_1.EntityTypeTable, { children: [(0, jsx_runtime_1.jsx)(material_1.TableHead, { children: (0, jsx_runtime_1.jsxs)(entity_type_table_1.EntityTypeTableHeaderRow, { children: [(0, jsx_runtime_1.jsx)(material_1.TableCell, { width: 260, children: "Link name" }), (0, jsx_runtime_1.jsxs)(material_1.TableCell, { sx: { minWidth: 262 }, children: ["Expected entity types", " ", (0, jsx_runtime_1.jsx)(question_icon_1.QuestionIcon, { tooltip: "When specified, only entities whose types are listed in this column will be able to be associated with a link" })] }), (0, jsx_runtime_1.jsxs)(entity_type_table_1.EntityTypeTableCenteredCell, { width: 210, children: ["Allowed number of links", " ", (0, jsx_runtime_1.jsx)(question_icon_1.QuestionIcon, { tooltip: "Require entities to specify a minimum or maximum number of links. A minimum value of 1 or more means that a link is required." })] }), (0, jsx_runtime_1.jsx)(material_1.TableCell, { width: type_menu_cell_1.TYPE_MENU_CELL_WIDTH })] }) }), (0, jsx_runtime_1.jsx)(material_1.TableBody, { children: fields.map(({ field, row, index }) => ((0, jsx_runtime_1.jsx)(LinkTypeRow, { linkIndex: index, onRemove: () => {
                        remove(index);
                    }, onUpdateVersion: (nextId) => {
                        setValue(`links.${index}.$id`, nextId, {
                            shouldDirty: true,
                        });
                    }, flash: row ? flashingRows.includes(row.$id) : false }, field.id))) }), (0, jsx_runtime_1.jsx)(material_1.TableFooter, { children: addingNewLink ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(InsertLinkRow, { inputRef: addingNewLinkRef, onCancel: cancelAddingNewLink, onAdd: handleAddEntityType, searchText: searchText, onSearchTextChange: setSearchText, createModalPopupState: createModalPopupState }), (0, jsx_runtime_1.jsx)(type_form_1.TypeFormModal, { as: exports.LinkTypeForm, popupState: createModalPopupState, modalTitle: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: ["Create new link", (0, jsx_runtime_1.jsx)(question_icon_1.QuestionIcon, { sx: {
                                            ml: 1.25,
                                        }, tooltip: (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: "You should only create a new link type if you can't find an existing one which corresponds to the relationship you're trying to capture." }) })] }), onSubmit: handleSubmit, submitButtonProps: { children: (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: "Create new link" }) }, getDefaultValues: () => searchText.length ? { name: searchText } : {} })] })) : (!isReadonly && ((0, jsx_runtime_1.jsx)(entity_type_table_1.EntityTypeTableButtonRow, { icon: (0, jsx_runtime_1.jsx)(design_system_1.StyledPlusCircleIcon, {}), onClick: () => {
                        setAddingNewLink(true, () => {
                            addingNewLinkRef.current?.focus();
                        });
                    }, children: "Add a link" }))) })] }));
};
exports.LinkListCard = LinkListCard;
